"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LongitudinalStrip = void 0;
/**
 * Longitudinal (vertical) strip
 */
class LongitudinalStrip {
    /**
     * Constructor
     *
     * @param zoneNumber
     *            zone number
     * @param west
     *            western longitude
     * @param east
     *            eastern longitude
     * @param expand
     *            expansion for range iterations over neighboring strips
     */
    constructor(zoneNumber, west, east, expand = 0) {
        this.zoneNumber = zoneNumber;
        this.west = west;
        this.east = east;
        this.expand = expand;
    }
    /**
     * Get the zone number
     *
     * @return zone number
     */
    getNumber() {
        return this.zoneNumber;
    }
    /**
     * Set the zone number
     *
     * @param zoneNumber
     *            zone number
     */
    setNumber(zoneNumber) {
        this.zoneNumber = zoneNumber;
    }
    /**
     * Get the western longitude
     *
     * @return western longitude
     */
    getWest() {
        return this.west;
    }
    /**
     * Set the western longitude
     *
     * @param west
     *            western longitude
     */
    setWest(west) {
        this.west = west;
    }
    /**
     * Get the eastern longitude
     *
     * @return eastern longitude
     */
    getEast() {
        return this.east;
    }
    /**
     * Set the eastern longitude
     *
     * @param east
     *            eastern longitude
     */
    setEast(east) {
        this.east = east;
    }
    /**
     * Get expand, number of additional neighbors to iterate over in combination
     * with this strip
     *
     * @return neighbor iteration expansion
     */
    getExpand() {
        return this.expand;
    }
    /**
     * Set the expand, number of additional neighbors to iterate over in
     * combination with this strip
     *
     * @param expand
     *            neighbor iteration expansion
     */
    setExpand(expand) {
        this.expand = expand;
    }
}
exports.LongitudinalStrip = LongitudinalStrip;
//# sourceMappingURL=LongitudinalStrip.js.map